export const whereQuestions = [
  {
    questionNumber: 1,
    questionText: "Who scheduled the client meeting for tomorrow?",
    choices: {
      A: "In the conference room.",
      B: "Ms. Park from Client Relations.",
      C: "After lunch.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "내일 고객 미팅을 누가 예약했나요?",
      choices: {
        A: "회의실에서요.",
        B: "고객 관계 부서의 박 씨요.",
        C: "점심 식사 후에요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 박 씨라는 특정 인물을 언급하고 있습니다. A는 장소에 대한 답변이고, C는 시간에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 2,
    questionText: "Who will lead the training session on Friday?",
    choices: {
      A: "Mr. Johnson, our training manager.",
      B: "At 1 p.m.",
      C: "In the main hall.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "금요일 교육 세션을 누가 이끌 예정인가요?",
      choices: {
        A: "우리 교육 매니저인 존슨 씨요.",
        B: "오후 1시에요.",
        C: "메인 홀에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 존슨 씨라는 특정 인물을 언급하고 있습니다. B는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 3,
    questionText: "Who will present the sales report at the conference?",
    choices: {
      A: "Tomorrow morning.",
      B: "In the conference hall.",
      C: "Mr. Lee, our sales director.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 컨퍼런스에서 판매 보고서를 발표할 예정인가요?",
      choices: {
        A: "내일 아침에요.",
        B: "컨퍼런스 홀에서요.",
        C: "우리 영업 이사인 이 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 이 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, B는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 4,
    questionText: "Who approved the new marketing strategy?",
    choices: {
      A: "Ms. Johnson, our marketing manager.",
      B: "Next week.",
      C: "In the marketing department.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 새로운 마케팅 전략을 승인했나요?",
      choices: {
        A: "우리 마케팅 매니저인 존슨 씨요.",
        B: "다음 주에요.",
        C: "마케팅 부서에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 존슨 씨라는 특정 인물을 언급하고 있습니다. B는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 5,
    questionText: "Who designed the company brochure?",
    choices: {
      A: "Next Monday.",
      B: "In the design studio.",
      C: "Mr. Davis, our graphic designer.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 회사 브로셔를 디자인했나요?",
      choices: {
        A: "다음 월요일에요.",
        B: "디자인 스튜디오에서요.",
        C: "우리 그래픽 디자이너인 데이비스 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 데이비스 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, B는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 6,
    questionText: "Who booked the venue for next week's conference?",
    choices: {
      A: "Tomorrow morning.",
      B: "Mr. Park, our event coordinator.",
      C: "In the banquet hall.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "누가 다음 주 컨퍼런스 장소를 예약했나요?",
      choices: {
        A: "내일 아침에요.",
        B: "우리 이벤트 코디네이터인 박 씨요.",
        C: "연회장에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 박 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 7,
    questionText: "Who sent the updated schedule to all participants?",
    choices: {
      A: "Mr. Kim, our project manager.",
      B: "Today at noon.",
      C: "In the email system.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 모든 참가자에게 업데이트된 일정을 보냈나요?",
      choices: {
        A: "우리 프로젝트 매니저인 김 씨요.",
        B: "오늘 정오에요.",
        C: "이메일 시스템에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 김 씨라는 특정 인물을 언급하고 있습니다. B는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 8,
    questionText: "Who will lead the safety training session?",
    choices: {
      A: "This afternoon.",
      B: "Before the workshop.",
      C: "Mr. Brown, our safety officer.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 안전 교육 세션을 이끌 예정인가요?",
      choices: {
        A: "오늘 오후에요.",
        B: "워크숍 전에요.",
        C: "우리 안전 담당관인 브라운 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 브라운 씨라는 특정 인물을 언급하고 있습니다. A와 B는 시간에 대한 답변으로, 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 9,
    questionText: "Who confirmed the client's reservation?",
    choices: {
      A: "Yesterday.",
      B: "Ms. Chen, our receptionist.",
      C: "At the front desk.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "누가 고객의 예약을 확인했나요?",
      choices: {
        A: "어제요.",
        B: "우리 접수원인 첸 씨요.",
        C: "접수대에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 첸 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 10,
    questionText: "Who provided the financial forecast?",
    choices: {
      A: "Mr. Davis, our CFO.",
      B: "At 3 p.m.",
      C: "In the annual report.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 재무 예측을 제공했나요?",
      choices: {
        A: "우리 CFO인 데이비스 씨요.",
        B: "오후 3시에요.",
        C: "연간 보고서에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 데이비스 씨라는 특정 인물을 언급하고 있습니다. B는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 11,
    questionText: "Who reviewed the legal contract?",
    choices: {
      A: "This morning.",
      B: "In the legal department.",
      C: "Ms. Garcia, our legal counsel.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 법적 계약서를 검토했나요?",
      choices: {
        A: "오늘 아침에요.",
        B: "법무 부서에서요.",
        C: "우리 법률 고문인 가르시아 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 가르시아 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, B는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 12,
    questionText: "Who scheduled the maintenance check?",
    choices: {
      A: "Tomorrow afternoon.",
      B: "The facilities manager.",
      C: "In the maintenance shed.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "누가 유지보수 점검을 예약했나요?",
      choices: {
        A: "내일 오후에요.",
        B: "시설 관리자요.",
        C: "유지보수 창고에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 시설 관리자라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 13,
    questionText: "Who compiled the quarterly performance data?",
    choices: {
      A: "Mr. Johnson in the analytics team.",
      B: "Next quarter.",
      C: "On the company server.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 분기별 성과 데이터를 취합했나요?",
      choices: {
        A: "분석팀의 존슨 씨요.",
        B: "다음 분기에요.",
        C: "회사 서버에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 존슨 씨라는 특정 인물을 언급하고 있습니다. B는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 14,
    questionText: "Who negotiated the supplier agreement?",
    choices: {
      A: "Before the deadline.",
      B: "In the procurement office.",
      C: "Mr. Wilson, our procurement director.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 공급업체 계약을 협상했나요?",
      choices: {
        A: "마감일 전에요.",
        B: "조달 사무실에서요.",
        C: "우리 조달 이사인 윌슨 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 윌슨 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, B는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 15,
    questionText: "Who prepared the meeting agenda?",
    choices: {
      A: "Yesterday.",
      B: "Ms. Robinson, our executive assistant.",
      C: "In the main conference room.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "누가 회의 의제를 준비했나요?",
      choices: {
        A: "어제요.",
        B: "우리 행정 보조인 로빈슨 씨요.",
        C: "메인 회의실에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 로빈슨 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 16,
    questionText: "Who organized the team-building activity?",
    choices: {
      A: "Mr. Chang, our HR coordinator.",
      B: "At the end of the month.",
      C: "In the courtyard.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 팀 빌딩 활동을 조직했나요?",
      choices: {
        A: "우리 인사 코디네이터인 장 씨요.",
        B: "월말에요.",
        C: "안뜰에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 장 씨라는 특정 인물을 언급하고 있습니다. B는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 17,
    questionText: "Who will operate the new software system?",
    choices: {
      A: "This evening.",
      B: "In the IT workshop.",
      C: "Ms. Patel, our IT specialist.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 새로운 소프트웨어 시스템을 운영할 예정인가요?",
      choices: {
        A: "오늘 저녁에요.",
        B: "IT 워크숍에서요.",
        C: "우리 IT 전문가인 파텔 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 파텔 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, B는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 18,
    questionText: "Who confirmed the flight arrangements?",
    choices: {
      A: "Tomorrow morning.",
      B: "Ms. Wong, our travel agent.",
      C: "At the airline desk.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "누가 항공편 준비를 확인했나요?",
      choices: {
        A: "내일 아침에요.",
        B: "우리 여행사 직원인 웡 씨요.",
        C: "항공사 데스크에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 웡 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 19,
    questionText: "Who changed the office layout plan?",
    choices: {
      A: "Mr. Green, our facilities planner.",
      B: "Next week.",
      C: "In the lobby area.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 사무실 레이아웃 계획을 변경했나요?",
      choices: {
        A: "우리 시설 계획자인 그린 씨요.",
        B: "다음 주에요.",
        C: "로비 구역에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 그린 씨라는 특정 인물을 언급하고 있습니다. B는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 20,
    questionText: "Who sent the emergency notification?",
    choices: {
      A: "This morning.",
      B: "On the intranet.",
      C: "Ms. Evans, our communications director.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 긴급 알림을 보냈나요?",
      choices: {
        A: "오늘 아침에요.",
        B: "인트라넷에서요.",
        C: "우리 커뮤니케이션 이사인 에반스 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 에반스 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, B는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 21,
    questionText: "Who accounted for the unexpected expenses?",
    choices: {
      A: "Yesterday afternoon.",
      B: "Mr. Turner, our accountant.",
      C: "In the expense report.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "누가 예상치 못한 비용을 설명했나요?",
      choices: {
        A: "어제 오후에요.",
        B: "우리 회계사인 터너 씨요.",
        C: "지출 보고서에서요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 터너 씨라는 특정 인물을 언급하고 있습니다. A는 시간에 대한 답변이고, C는 장소에 대한 답변으로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 22,
    questionText: "Who reserved the meeting room for this afternoon?",
    choices: {
      A: "I can reverse the charges on your card.",
      B: "Mr. Kim, our office manager.",
      C: "Please meet the attendees at reception.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "누가 오늘 오후 회의실을 예약했나요?",
      choices: {
        A: "귀하의 카드에 청구된 금액을 취소해 드릴 수 있습니다.",
        B: "우리 사무실 관리자인 김 씨요.",
        C: "접수처에서 참석자들을 만나주세요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. B는 김 씨라는 특정 인물을 언급하고 있습니다. A는 서비스에 대한 답변이고, C는 요청이나 지시로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 23,
    questionText: "Who held the annual shareholders meeting?",
    choices: {
      A: "I can help prepare the agenda.",
      B: "Please hold the call until the Chairman arrives.",
      C: "Ms. Chang, our corporate secretary.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 연례 주주 총회를 진행했나요?",
      choices: {
        A: "의제 준비를 도와드릴 수 있습니다.",
        B: "의장이 도착할 때까지 통화를 보류해 주세요.",
        C: "우리 기업 비서인 장 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 장 씨라는 특정 인물을 언급하고 있습니다. A는 제안에 대한 답변이고, B는 요청이나 지시로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 24,
    questionText: "Who closed the office early on Friday?",
    choices: {
      A: "Ms. Park, the facility manager.",
      B: "The clothes were taken for cleaning.",
      C: "Please close the windows before you leave.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 금요일에 사무실을 일찍 닫았나요?",
      choices: {
        A: "시설 관리자인 박 씨요.",
        B: "옷은 세탁을 위해 가져갔어요.",
        C: "떠나기 전에 창문을 닫아주세요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 박 씨라는 특정 인물을 언급하고 있습니다. B는 관련 없는 사항에 대한 답변이고, C는 요청이나 지시로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 25,
    questionText: "Who ordered the office supplies yesterday?",
    choices: {
      A: "I noticed an odor in the storage room.",
      B: "Please supply more paper to each department.",
      C: "Ms. Lee, the office manager.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 어제 사무용품을 주문했나요?",
      choices: {
        A: "저장실에서 냄새가 나는 것을 발견했어요.",
        B: "각 부서에 종이를 더 공급해 주세요.",
        C: "사무실 관리자인 이 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 이 씨라는 특정 인물을 언급하고 있습니다. A는 관련 없는 상황에 대한 진술이고, B는 요청이나 지시로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 26,
    questionText: "Who approved the new policy?",
    choices: {
      A: "I can prove the accuracy of the data.",
      B: "Please apply the changes immediately.",
      C: "Ms. Kim, our policy analyst.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "누가 새 정책을 승인했나요?",
      choices: {
        A: "데이터의 정확성을 증명할 수 있습니다.",
        B: "변경 사항을 즉시 적용해 주세요.",
        C: "정책 분석가인 김 씨요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. C는 김 씨라는 특정 인물을 언급하고 있습니다. A는 관련 없는 능력에 대한 진술이고, B는 요청이나 지시로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 27,
    questionText: "Who designed the company logo?",
    choices: {
      A: "Mr. Lee, our graphic designer.",
      B: "I can sign the contract now.",
      C: "Please log on to the portal.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 회사 로고를 디자인했나요?",
      choices: {
        A: "그래픽 디자이너인 이 씨요.",
        B: "지금 계약서에 서명할 수 있습니다.",
        C: "포털에 로그인해 주세요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 이 씨라는 특정 인물을 언급하고 있습니다. B는 관련 없는 행동에 대한 진술이고, C는 요청이나 지시로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 28,
    questionText: "Who hired the new sales associate last month?",
    choices: {
      A: "Ms. Johnson, the hiring manager.",
      B: "I can pay a higher salary.",
      C: "Please assist the new associate with onboarding.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누가 지난달에 새 영업 담당자를 고용했나요?",
      choices: {
        A: "채용 관리자인 존슨 씨요.",
        B: "더 높은 급여를 지급할 수 있습니다.",
        C: "새 담당자의 온보딩을 도와주세요.",
      },
    },
    explanation:
      "Who로 시작하는 질문은 사람에 대한 정보를 요구합니다. A는 존슨 씨라는 특정 인물을 언급하고 있습니다. B는 관련 없는 능력에 대한 진술이고, C는 요청이나 지시로, 둘 다 질문한 사람과 무관합니다.",
  },
  {
    questionNumber: 29,
    questionText: "Where is the marketing department?",
    choices: {
      A: "It's next to the HR office.",
      B: "By 5 p.m.",
      C: "With Mr. Han.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "마케팅 부서는 어디에 있나요?",
      choices: {
        A: "인사부 옆에 있습니다.",
        B: "오후 5시까지요.",
        C: "한 씨와 함께요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 인사부 옆이라는 특정 위치를 언급하고 있습니다. B는 시간에 관한 표현이고, C는 사람과 관련된 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 30,
    questionText: "Where can I park my car?",
    choices: {
      A: "Every morning.",
      B: "In the underground garage.",
      C: "A blue compact.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "제 차를 어디에 주차할 수 있나요?",
      choices: {
        A: "매일 아침에요.",
        B: "지하 주차장에요.",
        C: "파란색 소형차요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. B는 지하 주차장이라는 특정 위치를 언급하고 있습니다. A는 시간에 관한 표현이고, C는 차량 유형에 대한 설명으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 31,
    questionText: "Where did you meet the new client?",
    choices: {
      A: "Next week.",
      B: "In the break room.",
      C: "For lunch.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "새 고객을 어디서 만났나요?",
      choices: {
        A: "다음 주에요.",
        B: "휴게실에서요.",
        C: "점심 식사를 위해서요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. B는 휴게실이라는 특정 위치를 언급하고 있습니다. A는 시간에 관한 표현이고, C는 목적에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 32,
    questionText: "Where will the conference be held?",
    choices: {
      A: "For the sales team.",
      B: "At the Grand Hotel.",
      C: "On Monday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "컨퍼런스는 어디서 개최될 예정인가요?",
      choices: {
        A: "영업팀을 위해서요.",
        B: "그랜드 호텔에서요.",
        C: "월요일에요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. B는 그랜드 호텔이라는 특정 위치를 언급하고 있습니다. A는 대상에 관한 표현이고, C는 시간에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 33,
    questionText: "Where do you usually eat lunch?",
    choices: {
      A: "With coworkers.",
      B: "In the office kitchen.",
      C: "A tuna sandwich.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "보통 점심을 어디서 드시나요?",
      choices: {
        A: "동료들과 함께요.",
        B: "사무실 주방에서요.",
        C: "참치 샌드위치요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. B는 사무실 주방이라는 특정 위치를 언급하고 있습니다. A는 함께하는 사람에 관한 표현이고, C는 음식 종류에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 34,
    questionText: "Where are the shipping documents?",
    choices: {
      A: "On your desk.",
      B: "By tomorrow.",
      C: "For the finance team.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "배송 서류는 어디에 있나요?",
      choices: {
        A: "당신의 책상 위에 있습니다.",
        B: "내일까지요.",
        C: "재무팀을 위해서요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 책상 위라는 특정 위치를 언급하고 있습니다. B는 시간에 관한 표현이고, C는 목적에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 35,
    questionText: "Where can I find the user manual?",
    choices: {
      A: "It's available online.",
      B: "Before the update.",
      C: "A technical document.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "사용자 매뉴얼은 어디서 찾을 수 있나요?",
      choices: {
        A: "온라인에서 이용 가능합니다.",
        B: "업데이트 전에요.",
        C: "기술 문서입니다.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 온라인이라는 특정 위치를 언급하고 있습니다. B는 시간에 관한 표현이고, C는 문서 유형에 관한 설명으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 36,
    questionText: "Where is the nearest bus stop?",
    choices: {
      A: "Around the corner.",
      B: "Every 30 minutes.",
      C: "With a transfer.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "가장 가까운 버스 정류장은 어디에 있나요?",
      choices: {
        A: "모퉁이를 돌면 있습니다.",
        B: "30분마다요.",
        C: "환승과 함께요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 모퉁이를 돌면 있다는 특정 위치를 언급하고 있습니다. B는 시간 간격에 관한 표현이고, C는 이동 방법에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 37,
    questionText: "Where should I return this laptop?",
    choices: {
      A: "To the IT help desk.",
      B: "Because it's broken.",
      C: "It's a new model.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 노트북은 어디에 반납해야 하나요?",
      choices: {
        A: "IT 헬프데스크에요.",
        B: "고장났기 때문이에요.",
        C: "새 모델입니다.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 IT 헬프데스크라는 특정 위치를 언급하고 있습니다. B는 이유에 관한 표현이고, C는 노트북에 대한 설명으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 38,
    questionText: "Where do I sign the receipt?",
    choices: {
      A: "In blue ink.",
      B: "At the bottom.",
      C: "After delivery.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "영수증에 어디에 서명해야 하나요?",
      choices: {
        A: "파란색 잉크로요.",
        B: "하단에요.",
        C: "배송 후에요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. B는 하단이라는 특정 위치를 언급하고 있습니다. A는 방법에 관한 표현이고, C는 시간에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 39,
    questionText: "Where is the accounting office?",
    choices: {
      A: "It's across from the break room.",
      B: "I counted the total.",
      C: "I think we should leave now.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회계 사무실은 어디에 있나요?",
      choices: {
        A: "휴게실 맞은편에 있습니다.",
        B: "총액을 계산했습니다.",
        C: "지금 떠나야 한다고 생각합니다.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 휴게실 맞은편이라는 특정 위치를 언급하고 있습니다. B는 계산에 관한 표현이고, C는 의견 제시로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 40,
    questionText: "Where can I find the new printer?",
    choices: {
      A: "Next to the supply shelf.",
      B: "I printed the report already.",
      C: "Yes, I saw it yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새 프린터는 어디서 찾을 수 있나요?",
      choices: {
        A: "비품 선반 옆에요.",
        B: "이미 보고서를 인쇄했어요.",
        C: "네, 어제 봤어요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 비품 선반 옆이라는 특정 위치를 언급하고 있습니다. B는 과거 행동에 관한 표현이고, C는 확인에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 41,
    questionText: "Where are the visitor badges kept?",
    choices: {
      A: "In the drawer near the door.",
      B: "I visited the website this morning.",
      C: "They're available online.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "방문자 배지는 어디에 보관되어 있나요?",
      choices: {
        A: "문 근처 서랍에요.",
        B: "오늘 아침에 웹사이트를 방문했어요.",
        C: "온라인으로 이용 가능합니다.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 문 근처 서랍이라는 특정 위치를 언급하고 있습니다. B는 과거 행동에 관한 표현이고, C는 이용 방법에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 42,
    questionText: "Where is the IT support team located?",
    choices: {
      A: "On the third floor.",
      B: "They solved the issue.",
      C: "I think it's broken.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "IT 지원팀은 어디에 위치해 있나요?",
      choices: {
        A: "3층에요.",
        B: "그들이 문제를 해결했어요.",
        C: "고장난 것 같아요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 3층이라는 특정 위치를 언급하고 있습니다. B는 과거 행동에 관한 표현이고, C는 상태에 관한 의견으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 43,
    questionText: "Where should I return this file?",
    choices: {
      A: "To Mr. Lee's desk.",
      B: "I filed it already.",
      C: "He reviewed the report.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 파일은 어디에 반납해야 하나요?",
      choices: {
        A: "이 씨의 책상에요.",
        B: "이미 파일링했어요.",
        C: "그가 보고서를 검토했어요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 이 씨의 책상이라는 특정 위치를 언급하고 있습니다. B는 과거 행동에 관한 표현이고, C는 관련 없는 행동에 대한 진술로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 44,
    questionText: "Where is the training session?",
    choices: {
      A: "In Conference Room A.",
      B: "I trained last month.",
      C: "That was very helpful.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "교육 세션은 어디에서 진행되나요?",
      choices: {
        A: "회의실 A에서요.",
        B: "저는 지난달에 교육을 받았어요.",
        C: "그것은 매우 유용했어요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 회의실 A라는 특정 위치를 언급하고 있습니다. B는 과거 경험에 관한 표현이고, C는 평가에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 45,
    questionText: "Where did she put the inventory sheet?",
    choices: {
      A: "In the cabinet under the monitor.",
      B: "She's an intern.",
      C: "I think it's almost done.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그녀가 재고 시트를 어디에 두었나요?",
      choices: {
        A: "모니터 아래 캐비닛에요.",
        B: "그녀는 인턴이에요.",
        C: "거의 완료된 것 같아요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 모니터 아래 캐비닛이라는 특정 위치를 언급하고 있습니다. B는 사람에 관한 설명이고, C는 상태에 관한 의견으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 46,
    questionText: "Where can we hang the posters?",
    choices: {
      A: "On the bulletin board by the elevator.",
      B: "We handed them out.",
      C: "Because it's urgent.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "포스터를 어디에 걸 수 있나요?",
      choices: {
        A: "엘리베이터 옆 게시판에요.",
        B: "우리가 그것들을 나눠줬어요.",
        C: "긴급하기 때문이에요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 엘리베이터 옆 게시판이라는 특정 위치를 언급하고 있습니다. B는 과거 행동에 관한 표현이고, C는 이유에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 47,
    questionText: "Where are the customer service representatives?",
    choices: {
      A: "They're at their desks answering calls.",
      B: "I received a call earlier.",
      C: "Customer feedback is important.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "고객 서비스 담당자들은 어디에 있나요?",
      choices: {
        A: "그들은 자신의 책상에서 전화를 받고 있어요.",
        B: "저는 일찍 전화를 받았어요.",
        C: "고객 피드백은 중요해요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 자신의 책상이라는 특정 위치를 언급하고 있습니다. B는 과거 경험에 관한 표현이고, C는 중요성에 관한 의견으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 48,
    questionText: "Where is the cafeteria located?",
    choices: {
      A: "On the first floor, next to the lobby.",
      B: "I had coffee this morning.",
      C: "Let's take a break soon.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "구내식당은 어디에 위치해 있나요?",
      choices: {
        A: "1층, 로비 옆에요.",
        B: "오늘 아침에 커피를 마셨어요.",
        C: "곧 휴식을 취합시다.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. A는 1층, 로비 옆이라는 특정 위치를 언급하고 있습니다. B는 과거 행동에 관한 표현이고, C는 제안에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 49,
    questionText: "Where are the invoices stored?",
    choices: {
      A: "I voiced my concerns already.",
      B: "In the locked cabinet in the back room.",
      C: "That depends on the client.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "인보이스는 어디에 보관되어 있나요?",
      choices: {
        A: "이미 제 우려를 표현했어요.",
        B: "뒷방의 잠긴 캐비닛에요.",
        C: "고객에 따라 다릅니다.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. B는 뒷방의 잠긴 캐비닛이라는 특정 위치를 언급하고 있습니다. A는 과거 행동에 관한 표현이고, C는 조건부 상황에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 50,
    questionText: "Where can I catch a taxi near here?",
    choices: {
      A: "I texted him earlier.",
      B: "We should ask the manager first.",
      C: "Just outside the main entrance.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 근처에서 택시를 어디서 탈 수 있나요?",
      choices: {
        A: "저는 일찍 그에게 문자를 보냈어요.",
        B: "먼저 매니저에게 물어봐야 해요.",
        C: "정문 바로 밖에서요.",
      },
    },
    explanation:
      "Where로 시작하는 질문은 장소에 대한 정보를 요구합니다. C는 정문 바로 밖이라는 특정 위치를 언급하고 있습니다. A는 과거 행동에 관한 표현이고, B는 제안에 관한 표현으로, 둘 다 장소를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 51,
    questionText: "Why was the meeting postponed?",
    choices: {
      A: "There was a scheduling conflict.",
      B: "The meeting room.",
      C: "I'll check the list later.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의가 왜 연기되었나요?",
      choices: {
        A: "일정이 충돌했어요.",
        B: "회의실이요.",
        C: "나중에 목록을 확인할게요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 일정 충돌이라는 구체적인 이유를 제시합니다. B는 장소에 관한 명사구이고, C는 미래 행동에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 52,
    questionText: "Why didn't he submit the report?",
    choices: {
      A: "The financial report.",
      B: "He was out sick yesterday.",
      C: "I saw him at the cafeteria.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그는 왜 보고서를 제출하지 않았나요?",
      choices: {
        A: "재무 보고서요.",
        B: "그는 어제 아파서 결근했어요.",
        C: "저는 그를 구내식당에서 봤어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. B는 아파서 결근했다는 구체적인 이유를 제시합니다. A는 명사구이고, C는 과거 관찰에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 53,
    questionText: "Why is the elevator not working?",
    choices: {
      A: "The maintenance guy.",
      B: "I'm going to the lobby.",
      C: "It's being repaired right now.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "엘리베이터가 왜 작동하지 않나요?",
      choices: {
        A: "유지보수 담당자요.",
        B: "로비로 가고 있어요.",
        C: "지금 수리 중이에요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. C는 수리 중이라는 구체적인 이유를 제시합니다. A는 명사구이고, B는 현재 행동에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 54,
    questionText: "Why did they cancel the workshop?",
    choices: {
      A: "The training manual.",
      B: "There weren't enough participants.",
      C: "That's a great idea.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그들은 왜 워크숍을 취소했나요?",
      choices: {
        A: "교육 매뉴얼이요.",
        B: "참가자가 충분하지 않았어요.",
        C: "그것은 좋은 아이디어예요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. B는 참가자 부족이라는 구체적인 이유를 제시합니다. A는 명사구이고, C는 의견에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 55,
    questionText: "Why are you leaving early today?",
    choices: {
      A: "I have a dentist appointment.",
      B: "The office door.",
      C: "Yes, that's correct.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 왜 일찍 퇴근하시나요?",
      choices: {
        A: "치과 예약이 있어요.",
        B: "사무실 문이요.",
        C: "네, 맞습니다.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 치과 예약이라는 구체적인 이유를 제시합니다. B는 명사구이고, C는 확인에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 56,
    questionText: "Why was the package returned?",
    choices: {
      A: "It's in the storage room.",
      B: "The shipping label.",
      C: "The address was incorrect.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "왜 패키지가 반송되었나요?",
      choices: {
        A: "보관실에 있어요.",
        B: "배송 라벨이요.",
        C: "주소가 잘못되었어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. C는 주소 오류라는 구체적인 이유를 제시합니다. A는 위치에 관한 표현이고, B는 명사구로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 57,
    questionText: "Why aren't we using the projector?",
    choices: {
      A: "It's not connecting properly.",
      B: "The conference table.",
      C: "We'll have lunch at noon.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "왜 우리는 프로젝터를 사용하지 않나요?",
      choices: {
        A: "제대로 연결되지 않고 있어요.",
        B: "회의 테이블이요.",
        C: "우리는 정오에 점심을 먹을 거예요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 연결 문제라는 구체적인 이유를 제시합니다. B는 명사구이고, C는 미래 계획에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 58,
    questionText: "Why did Mr. Lee go to the warehouse?",
    choices: {
      A: "The delivery truck.",
      B: "I'll join you later.",
      C: "To check the inventory.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 씨는 왜 창고에 갔나요?",
      choices: {
        A: "배송 트럭이요.",
        B: "나중에 합류할게요.",
        C: "재고를 확인하기 위해서요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. C는 재고 확인이라는 구체적인 목적을 제시합니다. A는 명사구이고, B는 미래 행동에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 59,
    questionText: "Why wasn't the invoice approved?",
    choices: {
      A: "The accounting team.",
      B: "That's not on the list.",
      C: "It had incorrect figures.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "왜 인보이스가 승인되지 않았나요?",
      choices: {
        A: "회계팀이요.",
        B: "그것은 목록에 없어요.",
        C: "잘못된 수치가 있었어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. C는 잘못된 수치라는 구체적인 이유를 제시합니다. A는 명사구이고, B는 현재 상태에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 60,
    questionText: "Why are there no chairs in the room?",
    choices: {
      A: "The furniture catalog.",
      B: "Let's email the client.",
      C: "They were moved for cleaning.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "왜 방에 의자가 없나요?",
      choices: {
        A: "가구 카탈로그요.",
        B: "고객에게 이메일을 보내죠.",
        C: "청소를 위해 옮겨졌어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. C는 청소를 위해 옮겨졌다는 구체적인 이유를 제시합니다. A는 명사구이고, B는 제안에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 61,
    questionText: "Why wasn't the projector working?",
    choices: {
      A: "It was unplugged by mistake.",
      B: "The projector screen.",
      C: "We'll start the meeting soon.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "왜 프로젝터가 작동하지 않았나요?",
      choices: {
        A: "실수로 플러그가 뽑혀 있었어요.",
        B: "프로젝터 스크린이요.",
        C: "곧 회의를 시작할 거예요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 플러그가 뽑혀 있었다는 구체적인 이유를 제시합니다. B는 명사구이고, C는 미래 행동에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 62,
    questionText: "Why are the chairs stacked in the hallway?",
    choices: {
      A: "The hallway's narrow.",
      B: "To clean the floors.",
      C: "I saw someone moving them.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "왜 의자들이 복도에 쌓여 있나요?",
      choices: {
        A: "복도가 좁아요.",
        B: "바닥을 청소하기 위해서요.",
        C: "누군가 그것들을 옮기는 것을 봤어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. B는 바닥 청소라는 구체적인 이유를 제시합니다. A는 상태를 설명하는 표현이고, C는 관찰한 사실을 진술한 것으로, 둘 다 이유를 묻는 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 63,
    questionText: "Why didn't you bring the brochures?",
    choices: {
      A: "I forgot them on my desk.",
      B: "The printed version.",
      C: "That's a good idea.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "왜 브로셔를 가져오지 않았나요?",
      choices: {
        A: "제 책상에 두고 왔어요.",
        B: "인쇄된 버전이요.",
        C: "좋은 생각이네요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 책상에 두고 왔다는 구체적인 이유를 제시합니다. B는 명사구이고, C는 의견을 표현한 것으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 64,
    questionText: "Why is the entrance blocked off?",
    choices: {
      A: "Because of construction work.",
      B: "The emergency exit.",
      C: "Let's take the elevator instead.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "왜 입구가 막혀 있나요?",
      choices: {
        A: "공사 때문이에요.",
        B: "비상구요.",
        C: "대신 엘리베이터를 타죠.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 공사라는 구체적인 이유를 제시합니다. B는 명사구이고, C는 제안을 표현한 것으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 65,
    questionText: "Why was the delivery delayed?",
    choices: {
      A: "The delivery truck.",
      B: "There was heavy traffic.",
      C: "He signed the invoice.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "왜 배송이 지연되었나요?",
      choices: {
        A: "배송 트럭이요.",
        B: "교통 체증이 심했어요.",
        C: "그가 송장에 서명했어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. B는 교통 체증이라는 구체적인 이유를 제시합니다. A는 명사구이고, C는 과거 행동에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 66,
    questionText: "Why are the lights off in the conference room?",
    choices: {
      A: "I turned them off after the session.",
      B: "The light switch.",
      C: "We'll book the room again.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "왜 회의실 불이 꺼져 있나요?",
      choices: {
        A: "세션 후에 제가 불을 껐어요.",
        B: "전등 스위치요.",
        C: "방을 다시 예약할게요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 세션 후에 불을 껐다는 구체적인 이유를 제시합니다. B는 명사구이고, C는 미래 행동에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 67,
    questionText: "Why aren't there any signs posted yet?",
    choices: {
      A: "I'll check again later.",
      B: "They haven't been printed.",
      C: "The posters are colorful.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "왜 아직 표지판이 게시되지 않았나요?",
      choices: {
        A: "나중에 다시 확인할게요.",
        B: "아직 인쇄되지 않았어요.",
        C: "포스터가 다채로워요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. B는 아직 인쇄되지 않았다는 구체적인 이유를 제시합니다. A는 미래 행동에 관한 표현이고, C는 포스터의 특성을 설명하는 것으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 68,
    questionText: "Why are there no water in the cooler?",
    choices: {
      A: "The cleaning schedule.",
      B: "There was a supply issue.",
      C: "Let's replace the bottle now.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "왜 정수기에 물이 없나요?",
      choices: {
        A: "청소 일정이요.",
        B: "공급 문제가 있었어요.",
        C: "지금 물통을 교체합시다.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. B는 공급 문제라는 구체적인 이유를 제시합니다. A는 명사구이고, C는 제안을 표현한 것으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 69,
    questionText: "Why did she cancel the reservation?",
    choices: {
      A: "The dinner menu.",
      B: "I'll meet you at 8.",
      C: "She had another appointment.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "왜 그녀가 예약을 취소했나요?",
      choices: {
        A: "저녁 메뉴요.",
        B: "8시에 만나요.",
        C: "그녀는 다른 약속이 있었어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. C는 다른 약속이 있었다는 구체적인 이유를 제시합니다. A는 명사구이고, B는 미래 약속에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 70,
    questionText: "Why are we starting the project next month?",
    choices: {
      A: "Because the budget is approved then.",
      B: "It's about marketing.",
      C: "We've sent the files already.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "왜 우리는 다음 달에 프로젝트를 시작하나요?",
      choices: {
        A: "그때 예산이 승인되기 때문이에요.",
        B: "마케팅에 관한 것이에요.",
        C: "우리는 이미 파일들을 보냈어요.",
      },
    },
    explanation:
      "Why로 시작하는 질문은 이유나 원인에 대한 정보를 요구합니다. A는 예산 승인이라는 구체적인 이유를 제시합니다. B는 주제에 관한 표현이고, C는 과거 행동에 관한 표현으로, 둘 다 이유를 묻는 질문과 무관합니다.",
  },

  {
    questionNumber: 71,
    questionText: "When is the staff orientation?",
    choices: {
      A: "On Monday morning.",
      B: "Yes, it's mandatory.",
      C: "I organized the materials.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "직원 오리엔테이션은 언제인가요?",
      choices: {
        A: "월요일 아침이요.",
        B: "네, 필수입니다.",
        C: "제가 자료를 정리했어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 월요일 아침이라는 구체적인 시간을 제시합니다. B는 필수 여부에 관한 표현이고, C는 과거 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 72,
    questionText: "When did Mr. Choi leave the office?",
    choices: {
      A: "The office door was closed.",
      B: "About an hour ago.",
      C: "He took his laptop.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "최 씨는 언제 사무실을 떠났나요?",
      choices: {
        A: "사무실 문이 닫혀 있었어요.",
        B: "약 한 시간 전이요.",
        C: "그는 노트북을 가져갔어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. B는 한 시간 전이라는 구체적인 시간을 제시합니다. A는 상태에 관한 표현이고, C는 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 73,
    questionText: "When will the renovations be finished?",
    choices: {
      A: "Next Friday, if there are no delays.",
      B: "I like the new layout.",
      C: "The contractor's name is Lewis.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "리모델링은 언제 완료될 예정인가요?",
      choices: {
        A: "지연이 없다면 다음 금요일이요.",
        B: "저는 새 레이아웃이 마음에 들어요.",
        C: "계약자의 이름은 루이스예요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 다음 금요일이라는 구체적인 시간을 제시합니다. B는 개인적인 의견이고, C는 사람에 관한 정보로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 74,
    questionText: "When can we expect the final budget report?",
    choices: {
      A: "After the finance meeting.",
      B: "A very detailed report.",
      C: "The manager will approve it.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "최종 예산 보고서는 언제 받을 수 있나요?",
      choices: {
        A: "재무 회의 이후에요.",
        B: "매우 상세한 보고서예요.",
        C: "매니저가 승인할 거예요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 재무 회의 이후라는 시간을 제시합니다. B는 보고서의 특성에 관한 표현이고, C는 미래 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 75,
    questionText: "When should I send the invoice?",
    choices: {
      A: "Before the end of the day.",
      B: "Yes, it's the updated version.",
      C: "I saw the email this morning.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "청구서는 언제 보내야 하나요?",
      choices: {
        A: "오늘 업무 종료 전에요.",
        B: "네, 업데이트된 버전이에요.",
        C: "오늘 아침에 이메일을 봤어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 오늘 업무 종료 전이라는 구체적인 시간을 제시합니다. B는 확인에 관한 표현이고, C는 과거 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 76,
    questionText: "When does the last train leave?",
    choices: {
      A: "I believe it's at 11:30 p.m.",
      B: "It's quite crowded.",
      C: "No, I haven't yet.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "막차는 언제 출발하나요?",
      choices: {
        A: "오후 11시 30분인 것 같아요.",
        B: "꽤 혼잡해요.",
        C: "아니요, 아직 안 했어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 오후 11시 30분이라는 구체적인 시간을 제시합니다. B는 상태에 관한 표현이고, C는 부정적인 응답으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 77,
    questionText: "When will the technician arrive?",
    choices: {
      A: "Around 2 p.m.",
      B: "The device is under warranty.",
      C: "Please reset it again.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "기술자는 언제 도착할 예정인가요?",
      choices: {
        A: "오후 2시경이요.",
        B: "그 기기는 보증 기간 내에 있어요.",
        C: "다시 재설정해 주세요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 오후 2시경이라는 구체적인 시간을 제시합니다. B는 상태에 관한 표현이고, C는 요청에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 78,
    questionText: "When are the sales figures announced?",
    choices: {
      A: "They were printed already.",
      B: "On the first of every month.",
      C: "Yes, they're accurate.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "판매 수치는 언제 발표되나요?",
      choices: {
        A: "이미 인쇄되었어요.",
        B: "매월 1일이요.",
        C: "네, 정확해요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. B는 매월 1일이라는 구체적인 날짜를 제시합니다. A는 과거 행동에 관한 표현이고, C는 확인에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 79,
    questionText: "When is our next client meeting?",
    choices: {
      A: "I booked the meeting room.",
      B: "On Thursday afternoon.",
      C: "It's about the new contract.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "다음 고객 미팅은 언제인가요?",
      choices: {
        A: "회의실을 예약했어요.",
        B: "목요일 오후요.",
        C: "새 계약에 관한 것이에요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. B는 목요일 오후라는 구체적인 시간을 제시합니다. A는 과거 행동에 관한 표현이고, C는 주제에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 80,
    questionText: "When should we launch the campaign?",
    choices: {
      A: "He approved the design.",
      B: "Yes, it's already planned.",
      C: "At the beginning of next quarter.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "캠페인은 언제 시작해야 하나요?",
      choices: {
        A: "그가 디자인을 승인했어요.",
        B: "네, 이미 계획되어 있어요.",
        C: "다음 분기 초에요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. C는 다음 분기 초라는 구체적인 시간을 제시합니다. A는 과거 행동에 관한 표현이고, B는 확인에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 81,
    questionText: "When will the marketing report be ready?",
    choices: {
      A: "By Thursday morning.",
      B: "Yes, it's very detailed.",
      C: "The manager reviewed it.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "마케팅 보고서는 언제 준비될 예정인가요?",
      choices: {
        A: "목요일 아침까지요.",
        B: "네, 매우 상세해요.",
        C: "매니저가 검토했어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 목요일 아침이라는 구체적인 시간을 제시합니다. B는 상세함에 관한 표현이고, C는 과거 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 82,
    questionText: "When is the product launch scheduled?",
    choices: {
      A: "A product brochure.",
      B: "On the 18th of May.",
      C: "I'll design the invitation.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "제품 출시는 언제로 예정되어 있나요?",
      choices: {
        A: "제품 브로셔요.",
        B: "5월 18일이요.",
        C: "초대장을 디자인할게요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. B는 5월 18일이라는 구체적인 날짜를 제시합니다. A는 물건에 관한 표현이고, C는 미래 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 83,
    questionText: "When should we reschedule the meeting?",
    choices: {
      A: "How about next Tuesday?",
      B: "That's a good suggestion.",
      C: "The projector is broken.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의를 언제로 일정을 변경해야 할까요?",
      choices: {
        A: "다음 화요일은 어떨까요?",
        B: "좋은 제안이네요.",
        C: "프로젝터가 고장났어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 다음 화요일이라는 구체적인 날짜를 제안합니다. B는 의견에 관한 표현이고, C는 상태에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 84,
    questionText: "When can I expect the delivery?",
    choices: {
      A: "A delivery notice.",
      B: "It should arrive this afternoon.",
      C: "The driver called earlier.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "배송은 언제쯤 받을 수 있을까요?",
      choices: {
        A: "배송 통지서요.",
        B: "오늘 오후에 도착할 예정이에요.",
        C: "운전기사가 일찍 전화했어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. B는 오늘 오후라는 구체적인 시간을 제시합니다. A는 물건에 관한 표현이고, C는 과거 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 85,
    questionText: "When is the cafeteria open?",
    choices: {
      A: "I think it opens at 8 a.m.",
      B: "Yes, I've been there.",
      C: "A breakfast menu.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "구내식당은 언제 열리나요?",
      choices: {
        A: "오전 8시에 연다고 생각해요.",
        B: "네, 거기 가봤어요.",
        C: "아침 메뉴요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 오전 8시라는 구체적인 시간을 제시합니다. B는 경험에 관한 표현이고, C는 물건에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 86,
    questionText: "When does the manager usually arrive?",
    choices: {
      A: "A busy schedule.",
      B: "Around 9:30 every day.",
      C: "The office is upstairs.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "매니저는 보통 언제 도착하나요?",
      choices: {
        A: "바쁜 일정이요.",
        B: "매일 9시 30분경이요.",
        C: "사무실은 위층에 있어요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. B는 매일 9시 30분경이라는 구체적인 시간을 제시합니다. A는 일정에 관한 표현이고, C는 위치에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 87,
    questionText: "When did they move to the new office?",
    choices: {
      A: "They relocated two weeks ago.",
      B: "A nice location.",
      C: "I'll check the address.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그들은 언제 새 사무실로 이사했나요?",
      choices: {
        A: "2주 전에 이전했어요.",
        B: "좋은 위치예요.",
        C: "주소를 확인해볼게요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 2주 전이라는 구체적인 시간을 제시합니다. B는 위치에 관한 표현이고, C는 미래 행동에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 88,
    questionText: "When are the documents due?",
    choices: {
      A: "The contract section.",
      B: "On my desk.",
      C: "By the end of the week.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "서류는 언제까지 제출해야 하나요?",
      choices: {
        A: "계약 섹션이요.",
        B: "제 책상 위에요.",
        C: "이번 주 말까지요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. C는 이번 주 말이라는 구체적인 시간을 제시합니다. A는 섹션에 관한 표현이고, B는 위치에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 89,
    questionText: "When is the next employee workshop?",
    choices: {
      A: "It's scheduled for next Friday.",
      B: "I read the flyer.",
      C: "A feedback session.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "다음 직원 워크숍은 언제인가요?",
      choices: {
        A: "다음 금요일로 예정되어 있어요.",
        B: "전단지를 읽었어요.",
        C: "피드백 세션이요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 다음 금요일이라는 구체적인 날짜를 제시합니다. B는 과거 행동에 관한 표현이고, C는 세션 유형에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 90,
    questionText: "When can we check in for the event?",
    choices: {
      A: "A printed invitation.",
      B: "I believe after 4 p.m.",
      C: "The event is on the 2nd floor.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "행사 체크인은 언제 할 수 있나요?",
      choices: {
        A: "인쇄된 초대장이요.",
        B: "오후 4시 이후로 알고 있어요.",
        C: "행사는 2층에서 열려요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. B는 오후 4시 이후라는 구체적인 시간을 제시합니다. A는 물건에 관한 표현이고, C는 위치에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 91,
    questionText: "When was the carpet replaced?",
    choices: {
      A: "Last November.",
      B: "I replaced the furniture.",
      C: "In the corner of the lobby.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "카펫은 언제 교체되었나요?",
      choices: {
        A: "지난 11월이요.",
        B: "가구를 교체했어요.",
        C: "로비 구석에요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 지난 11월이라는 구체적인 시간을 제시합니다. B는 '교체'라는 단어는 유사하지만 가구에 관한 표현이고, C는 위치에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 92,
    questionText: "When were the safety guidelines updated?",
    choices: {
      A: "A few months ago.",
      B: "They're posted on the wall.",
      C: "By the emergency exit.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "안전 지침은 언제 업데이트되었나요?",
      choices: {
        A: "몇 달 전이요.",
        B: "벽에 게시되어 있어요.",
        C: "비상구 옆이요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 몇 달 전이라는 시간을 제시합니다. B는 의미는 관련이 있지만 시간이 아닌 상태에 관한 표현이고, C는 장소에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 93,
    questionText: "When did the technician fix the lights?",
    choices: {
      A: "Yesterday afternoon.",
      B: "A lighting manual.",
      C: "Let's call maintenance again.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "기술자가 언제 조명을 수리했나요?",
      choices: {
        A: "어제 오후요.",
        B: "조명 설명서요.",
        C: "유지보수팀에 다시 전화해요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 어제 오후라는 구체적인 시간을 제시합니다. B는 '조명'이라는 단어는 유사하지만 시간과 무관한 물건에 관한 표현이고, C는 지시문으로 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 94,
    questionText: "When were the training sessions held?",
    choices: {
      A: "During the last week of August.",
      B: "They were helpful.",
      C: "In the meeting room.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "교육 세션은 언제 진행되었나요?",
      choices: {
        A: "8월 마지막 주 동안이요.",
        B: "유익했어요.",
        C: "회의실에서요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 8월 마지막 주라는 구체적인 시간을 제시합니다. B는 정답처럼 보일 수 있지만 시간이 아닌 평가에 관한 표현이고, C는 장소에 관한 표현으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 95,
    questionText: "When was the last software update completed?",
    choices: {
      A: "Early this morning.",
      B: "I completed a different task.",
      C: "Please restart the computer.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "마지막 소프트웨어 업데이트는 언제 완료되었나요?",
      choices: {
        A: "오늘 아침 일찍이요.",
        B: "다른 작업을 완료했어요.",
        C: "컴퓨터를 다시 시작해 주세요.",
      },
    },
    explanation:
      "When으로 시작하는 질문은 시간이나 날짜에 대한 정보를 요구합니다. A는 오늘 아침 일찍이라는 구체적인 시간을 제시합니다. B는 '완료'라는 단어는 유사하지만 다른 작업에 관한 표현이고, C는 명령문으로, 둘 다 시간을 묻는 질문과 무관합니다.",
  },
  {
    questionNumber: 96,
    questionText: "Whose laptop is on the conference table?",
    choices: {
      A: "It belongs to Mr. Patel.",
      B: "There's a meeting at 3 o'clock.",
      C: "The table was just cleaned.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의 테이블 위에 있는 노트북은 누구의 것인가요?",
      choices: {
        A: "파텔 씨의 것이에요.",
        B: "3시에 회의가 있어요.",
        C: "테이블이 방금 청소되었어요.",
      },
    },
    explanation:
      "Whose로 시작하는 질문은 소유권이나 소유자에 대한 정보를 요구합니다. A는 노트북이 파텔 씨의 것이라고 명확히 소유자를 밝히고 있습니다. B는 시간 정보를 제공하고 있어 소유권과 무관하며, C는 테이블의 상태에 대한 설명으로 역시 소유권 질문과 관련이 없습니다.",
  },
  {
    questionNumber: 97,
    questionText: "Whose umbrella is this by the door?",
    choices: {
      A: "It looks like Ms. Han's.",
      B: "Let's check the weather forecast.",
      C: "I'll grab my coat now.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "문 옆에 있는 이 우산은 누구의 것인가요?",
      choices: {
        A: "한 씨의 것 같아요.",
        B: "날씨 예보를 확인해 봅시다.",
        C: "지금 제 코트를 가져올게요.",
      },
    },
    explanation:
      "Whose로 시작하는 질문은 소유권이나 소유자에 대한 정보를 요구합니다. A는 우산이 한 씨의 것이라고 소유자를 밝히고 있습니다. B는 날씨 예보에 관한 내용으로 소유권과 무관하며, C는 화자 자신의 행동에 대한 설명으로 역시 소유권 질문과 관련이 없습니다.",
  },
  {
    questionNumber: 98,
    questionText: "Whose coffee is on the reception desk?",
    choices: {
      A: "I think it's Jack's.",
      B: "The reception area is very quiet.",
      C: "Would you like sugar in yours?",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "접수대 위에 있는 커피는 누구의 것인가요?",
      choices: {
        A: "잭의 것인 것 같아요.",
        B: "접수 구역이 매우 조용해요.",
        C: "당신 것에 설탕을 넣어드릴까요?",
      },
    },
    explanation:
      "Whose로 시작하는 질문은 소유권이나 소유자에 대한 정보를 요구합니다. A는 커피가 잭의 것이라고 소유자를 밝히고 있습니다. B는 접수 구역의 상태에 관한 내용으로 소유권과 무관하며, C는 상대방의 커피에 대한 질문으로 원래 질문의 답변이 아닙니다.",
  },
  {
    questionNumber: 99,
    questionText: "Whose phone has been ringing nonstop?",
    choices: {
      A: "That's mine. I'll answer it now.",
      B: "It's on the second shelf.",
      C: "Please turn your devices off.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "누구의 전화가 계속 울리고 있나요?",
      choices: {
        A: "제 것이에요. 지금 받을게요.",
        B: "두 번째 선반 위에 있어요.",
        C: "기기를 꺼주세요.",
      },
    },
    explanation:
      "Whose로 시작하는 질문은 소유권이나 소유자에 대한 정보를 요구합니다. A는 전화가 화자 자신의 것이라고 소유자를 밝히고 있습니다. B는 위치에 관한 정보로 소유권과 무관하며, C는 명령문으로 역시 소유권 질문과 관련이 없습니다.",
  },
  {
    questionNumber: 100,
    questionText: "Whose backpack is under the table?",
    choices: {
      A: "It belongs to the new intern.",
      B: "The table's a bit unstable.",
      C: "I'll clean up the meeting room.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "테이블 아래에 있는 백팩은 누구의 것인가요?",
      choices: {
        A: "새 인턴의 것이에요.",
        B: "테이블이 약간 불안정해요.",
        C: "회의실을 청소할게요.",
      },
    },
    explanation:
      "Whose로 시작하는 질문은 소유권이나 소유자에 대한 정보를 요구합니다. A는 백팩이 새 인턴의 것이라고 소유자를 밝히고 있습니다. B는 테이블의 상태에 관한 내용으로 소유권과 무관하며, C는 화자의 행동에 대한 설명으로 역시 소유권 질문과 관련이 없습니다.",
  },
];
